import { defineRouting } from "next-intl/routing";

export const intlConfig = {
  locales: ["en", "fr"],
  defaultLocale: "fr",
};

export const routing = defineRouting(intlConfig);
